import { AggregationField } from 'widgets/portfolioSummary/aggregation/fields/aggregationFieldPortfolio';

export interface PortfolioSummaryDrillDown {
    /*
     * The field drilling down on. We currently only support 'symbol' but have structured the state to be future prood
     */
    aggregationField: AggregationField;
    /*
     * The group name i.e. value we are drilling down on
     */
    groupName: string;
}
export interface PortfolioSummaryComponentState {
    drillDown?: PortfolioSummaryDrillDown;
}

export const initialPortfolioSummaryComponentState: PortfolioSummaryComponentState =
    {};
